import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { FormFiltersInterface } from '../interfaces/FormFiltersInterface';
import { TotalesMovimientosContables } from "../interfaces/TotalesMovimientosContablesInterface";
import { getFirstDayOfMonth, getLastDayOfMonth } from "../utils/utils";
import { RespuestaDescargarArchivoGdiSacDto } from "../models/respuestaDescargarArchivoGdiSacDto";

const obtenerTotalesMovimientosContables = async ( formFilters: FormFiltersInterface ) => {
    const { byPeriod, periodo, fechaInicio, fechaFin, codigoAccion, numeroOperacion } = formFilters;
    const url = 'siscred-api-contabilizacion/v1/peoplesoft/movimientostotal';
    const params = {
        fechaDesde: byPeriod ? getFirstDayOfMonth(periodo!) : fechaInicio!.toISOString().split('T')[0],
        fechaHasta: byPeriod ? getLastDayOfMonth(periodo!) : fechaFin!.toISOString().split('T')[0],
        codigoAccion: codigoAccion == 'Todas' ? '' : codigoAccion,
        NumeroOperacion: numeroOperacion ? numeroOperacion : ''
    };

    const response: AxiosResponse<TotalesMovimientosContables> = await axiosInstance.get(url, { params });
    return response;
}

const aprobarAsientosContables = async (formFilters: FormFiltersInterface, usuario: string = '') => {
    const { byPeriod, periodo, fechaInicio, fechaFin, codigoAccion, numeroOperacion } = formFilters;
    let url = 'siscred-api-contabilizacion/v1/peoplesoft/aprobarasientoscontables';
    const data = {
        fDesde: byPeriod ? getFirstDayOfMonth(periodo!) : fechaInicio!.toISOString().split('T')[0],
        fHasta: byPeriod ? getLastDayOfMonth(periodo!) : fechaFin!.toISOString().split('T')[0],
        accion: codigoAccion == 'Todas' ? '' : codigoAccion,
        nroOperacion: numeroOperacion ? numeroOperacion : '',
        usuario
    };

    const response: Promise<AxiosResponse> = axiosInstance.post(url, data);
    return response;
};

const enviarLayoutGdi = async (idsRegistros: number[], usuario: string = '') => {
    let url = 'siscred-api-contabilizacion/v1/peoplesoft/enviarlayoutgdi';
    const data = { registroIds: idsRegistros, usuario };
    const response: Promise<AxiosResponse> = axiosInstance.post(url, data);
    return response
}

const getArchivoGdiSac = async (ids: number[]) => {
    const url = `siscred-api-reportes/v1/archivo-externo/generararchivogdisac`;
    const response: Promise<AxiosResponse<RespuestaDescargarArchivoGdiSacDto>> = axiosInstance.post(url, {ids});
    return response;
};

export {
    getArchivoGdiSac,
    obtenerTotalesMovimientosContables,
    aprobarAsientosContables,
    enviarLayoutGdi
};